import type {
	UpdatePasswordPayload, UpdateUserPayload, User, WithApiData, UserResource,
	CreateUserHostnamePayload, ApiHostname, UpdateAccountPayload
} from "Interfaces";
import { ResourceType } from "Interfaces";
import { PATCH, DELETE, GET, POST } from "Data/API/Request";
import { deserializeJsonApiData, serializeJsonApiData } from "Data/Utils/JsonApi";

export const fetchUsers = (filters: Record<string, string>, token: string) => {
	return GET<UserResource[]>("users", token, filters)
		.then(response => deserializeJsonApiData(response));
};

export const resetAccountPassword = (payload: UpdatePasswordPayload, token: string) => {
	return PATCH(
		"account/password",
		token,
		serializeJsonApiData(ResourceType.USERS, payload)
	);
};

export const updateAccount = (payload: UpdateAccountPayload, token: string) => {
	return PATCH<User>(
		"account/profile",
		token,
		serializeJsonApiData(ResourceType.USERS, payload)
	).then((response: WithApiData<User>) => {
		return deserializeJsonApiData<User>(response);
	});
};

export const deleteAccount = (token: string) => {
	return DELETE("account", token);
};

export const updateUser = (payload: UpdateUserPayload, token: string) => {
	const { id, ...restPayload } = payload;

	return PATCH<User>(
		`users/${ id }`,
		token,
		serializeJsonApiData(ResourceType.USERS, restPayload)
	).then(response => deserializeJsonApiData(response));
};

export const createUserHostname = (payload: CreateUserHostnamePayload, token: string) => {
	const { userId, ...restPayload } = payload;

	return POST<ApiHostname>(
		`users/${ userId }/hostnames`,
		serializeJsonApiData(ResourceType.HOSTNAMES, restPayload),
		token
	).then(response => deserializeJsonApiData(response));
};

export const deleteUser = (userId: string, token: string) => {
	return DELETE(`users/${ userId }`, token);
};
